import clsx from 'clsx';
import style from './style.module.scss';

export const InputField = ({
    title,
    value,
    fieldName,
    onChange,
    init,
    points = null,
    err = null,
    displayErr = true,
    required = false,
    type = 'text',
    placeholder = '',
    lock = false,
    ...props
}) => {
    const isError = () => {
        if (err && err[fieldName]) {
            return true;
        }
        return false;
    };

    return (
        <div className={clsx(style.block, lock && style.disabled)}>
            <div className={style.top}>
                <div>
                    {title}
                    {required && ' *'}
                </div>

                {points !== null &&
                    (init ? (
                        <div className={style.points} style={{ color: style.green }}>
                            {`✓ ${points} points`}
                        </div>
                    ) : (
                        <div className={style.points}>(+{points} points)</div>
                    ))}
            </div>

            <input
                required={required}
                className={isError() ? style.error : undefined}
                type={type}
                id={fieldName}
                name={fieldName}
                placeholder={placeholder}
                value={value || ''}
                onChange={(e) => onChange(e.target.value, fieldName)}
                autoComplete={type === 'password' ? 'new-password' : 'on'}
                {...props}
            />

            {displayErr && isError() && (
                <div className={style.errorContainer}>
                    {err[fieldName] === true ? 'Veuillez préciser ce champ.' : err[fieldName]}
                </div>
            )}
        </div>
    );
};
